import Game from './stores/game'
import Microcosm from 'microcosm'

class Gifbowl extends Microcosm {

  constructor() {
    super()

    this.addStore('game', Game)
  }
}

export default Gifbowl



/** WEBPACK FOOTER **
 ** ./web/static/app/app.js
 **/